import React from 'react'
import { useImageLabelOverlayStyles } from './ImageLabelOverlay.styles'
import clsx from 'clsx'

interface Props {
  src: string // todo is there a better type?
  label?: string
  imgStyles?: string
}

const ImageLabelOverlay: React.FC<Props> = (props) => {
  const s = useImageLabelOverlayStyles()

  return <div className={s.container}>
    <img
      src={props.src} className={clsx(s.img, props.imgStyles)}
    />
    {props.label && <div className={s.imgLabel}>
      {props.label}
    </div>}
  </div>
}

export default ImageLabelOverlay
